/* eslint-disable import/no-cycle */
import { all } from 'redux-saga/effects'
import { authSagas } from './auth'
import { humanResourcesSagas } from './humanResources'
import { financialSagas } from './financial'
import { technicalDepSagas } from './technicalDep'
import { tasksSagas } from './tasks'
import { walletSagas } from './wallet'
import { agendaSagas } from './agenda'
import { filesSagas } from './files'
import { customerSagas } from './customer'
import { patrimonySagas } from './patrimony'
import { comercialSagas } from './comercial'
import { typesSagas } from './types'
import { adminSagas } from './admin'
import { formsSagas } from './forms'
import { managementSagas } from './management'

export default function* rootSaga() {
  yield all([
    ...authSagas,
    ...humanResourcesSagas,
    ...financialSagas,
    ...technicalDepSagas,
    ...tasksSagas,
    ...walletSagas,
    ...agendaSagas,
    ...filesSagas,
    ...customerSagas,
    ...patrimonySagas,
    ...comercialSagas,
    ...typesSagas,
    ...adminSagas,
    ...formsSagas,
    ...managementSagas,
  ])
}
